import React, { useState } from "react";
import SpecialOffers from "../../components/home/SpecialOffers/SpecialOffers";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";
import { Helmet } from "react-helmet";

const Offer = () => {
  const [prevLocation] = useState("");

  return (
    <div className="max-w-container mx-auto px-4">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Special Export Offers - RK Global Trader</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        />
        <meta
          name="description"
          content="Discover exclusive export offers and deals from RK Global Trader. Check our limited-time discounts on agriculture products, spices, and international trade commodities."
        />
        <meta
          name="keywords"
          content="RK Global Trader, special offers, export deals, discounted agriculture products, international trade discounts, export from India, trading website, import-export offers"
        />
        <meta
          name="author"
          content="RK Global Trader | Agriculture Product | Export from India"
        />
        <link rel="canonical" href="https://www.rkglobaltrader.com/offer" />
      </Helmet>

      <Breadcrumbs title="Special Offers" prevLocation={prevLocation} />

      <section className="pb-10">
        <h1 className="text-2xl font-titleFont font-bold text-primeColor mb-4">
          Limited-Time Export Offers
        </h1>
        <p className="text-base text-lightText mb-6">
          Explore our exclusive offers on high-quality agriculture products,
          spices, and other commodities for international trade. Save on bulk
          purchases and enjoy competitive pricing with RK Global Trader.
        </p>

        <SpecialOffers />

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600">
            Note: Offers are subject to availability and may change without
            prior notice. Contact us directly for custom export deals and
            quotation requests.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Offer;
